module.exports = __webpack_public_path__ + "index_pc/img/cate_6-7.7906dc68.png";